module.exports = __webpack_public_path__ + "img/IMG_1133.f05983b1.jpeg";